import React, { useState, Fragment } from 'react';
import { Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import * as yup from 'yup';

import i18n from 'i18next';

import Fetch from 'helpers/fetch';
import { getRegionData } from 'constants/regions';
import { buildUrl } from 'helpers/misc';
import { RESETPASSWORD } from 'constants/apis';
import ForgotPasswordForm from 'Components/Login/ForgotPasswordForm';
import { Loader } from 'Components/index';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();

  const [state, setState] = useState({
    hasError: false,
    errorMessage: '',
    isSubmitting: false,
  });

  const handleResendEmail = () => {
    setState({
      ...state,
      codeSentMessage: '',
      errorMessage: '',
      isSubmitting: false,
      hasError: false,
    });
  };

  const handleForgotSubmit = (values) => {
    localStorage.setItem('Region', values.region);

    setState({
      ...state,
      errorMessage: '',
      isSubmitting: true,
      hasError: false,
    });

    const params = {
      username: values.email,
      region: `${getRegionData(localStorage.getItem('Region')).value}`,
    };

    return Fetch.Get(buildUrl(RESETPASSWORD, params))
      .then((response) => {
        response.json().then((data) =>
          setState({
            ...state,
            isSubmitting: false,
            hasError: false,
            codeSentMessage: data.Message,
            errorMessage: '',
          }),
        );
      })
      .catch((err) => {
        if (err.response) {
          err.response.json().then((data) =>
            setState({
              ...state,
              errorMessage: data.Message,
              hasError: true,
              isSubmitting: false,
            }),
          );
        } else {
          setState({
            ...state,
            errorMessage: 'Error',
            hasError: true,
            isSubmitting: false,
          });
        }
      });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    if (name && name === 'region') {
      localStorage.setItem('Region', value);
    }
  };

  return (
    <Fragment>
      <Formik
        onSubmit={handleForgotSubmit}
        initialValues={{
          region: 0,
          email: '',
        }}
        validationSchema={yup.object().shape({
          region: yup
            .string()
            .matches(/^([^0-9]*)$/, i18n.t('login:form:region:error')),
          email: yup
            .string()
            .email()
            .required(i18n.t('login:form:email:error')),
        })}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <ForgotPasswordForm
            {...props}
            codeSentMessage={state.codeSentMessage}
            errorMessage={state.errorMessage}
            onResendEmail={handleResendEmail}
            onChange={handleOnChange}
          />
        )}
      </Formik>
      <Backdrop className={classes.backdrop} open={state.isSubmitting}>
        <Loader />
      </Backdrop>
    </Fragment>
  );
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/containers/Login/ForgotPassword.js